export enum StoreKey {
    RECEIPTS = 'receipts',
    PROCESSING_RECEIPTS = 'processing_receipts',
    SPACES = 'spaces',
    TAGS = 'tags',
    CATEGORY_GROUPS = 'category_groups',
}
